import { Back, Power3 } from 'gsap';
import * as PIXI from 'pixi.js';
import Preset from '../Preset';
import Ring from '../../graphics/Ring';
import { getPadding } from '../../utils/CoordinateCalculator';

const ANIMATION_DWELL = 0.1;
const DEFAULT_SECTIONS = [1, 1, 2, 2];

export default class StepUp extends Preset {
  constructor(app, sections = DEFAULT_SECTIONS) {
    super({ app, isFullScreen: true });

    this.sections = sections;
    this.sectionsSum = this.sections.reduce((a, b) => a + b, 0);

    this.rings = [];
    for (let i = 0; i < sections.length; i++) {
      this.rings.push(new Ring());
    }
  }

  update(model) {
    super.update(model);

    const { x, y, width, height } = this.root;
    const halfDuration = model.duration / 2;
    const twelvethDuration = model.duration / 12;
    const animationGapDuration = twelvethDuration;

    this.ringGapPx = getPadding(this.app.screen.height, 2);

    this.maxRadius = Math.sqrt((width / 2) ** 2 + height ** 2);
    this.center = new PIXI.Point(x + width / 2, y + height);

    this.perRingDuration =
      (halfDuration - ANIMATION_DWELL / 2 - animationGapDuration) /
      this.sections.length;

    this.previousRadius = 0;
    this.rings.forEach((ring, index) => {
      const sectionRatio = this.sections[index] / this.sectionsSum;
      const radius =
        index === this.sections.length - 1
          ? this.maxRadius + this.ringGapPx
          : this.previousRadius + this.root.height * sectionRatio;
      const thickness = radius - this.previousRadius;

      ring.color = this.primaryColor.clone();
      ring.center = this.center;
      ring.alpha = 0;
      ring.radius = this.previousRadius - this.ringGapPx;
      ring.thickness = 0;

      const growRing = {
        alpha: this.primaryColor.getAlpha(),
        radius: radius - this.ringGapPx,
        thickness: thickness - this.ringGapPx,
        duration: this.perRingDuration,
        ease: Back.easeOut,
      };
      const closeGap = {
        thickness,
        radius,
        duration: animationGapDuration,
        ease: Power3.easeInOut,
      };

      this.animate(ring)
        .to(growRing, this.perRingDuration * index)
        .to(closeGap, halfDuration - ANIMATION_DWELL / 2 - animationGapDuration)
        .reverseOut();

      this.previousRadius = radius;
    });
  }

  render() {
    super.render();
    this.rings.forEach((ring) => ring.draw(this.graphics));
  }
}
